/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Connect_Failed_NoteInputs */

const en_mcp_connect_failed_note = /** @type {(inputs: Mcp_Connect_Failed_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing was shared. Start the connection again from the app you’re using.`)
};

const es_mcp_connect_failed_note = /** @type {(inputs: Mcp_Connect_Failed_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se compartió nada. Vuelve a iniciar la conexión desde la app que estás usando.`)
};

/**
* | output |
* | --- |
* | "Nothing was shared. Start the connection again from the app you’re using." |
*
* @param {Mcp_Connect_Failed_NoteInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_connect_failed_note = /** @type {((inputs?: Mcp_Connect_Failed_NoteInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Connect_Failed_NoteInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_connect_failed_note(inputs)
	return en_mcp_connect_failed_note(inputs)
});